(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Mobile-Teacher_tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tabs = document.querySelectorAll('.mobile-product-tabs__tab');
    if (tabs.length === 0) return;

    // Find the section element by finding the parent of the tabs
    const tabsContainer = tabs[0].closest('.mobile-product-tabs-section');
    if (!tabsContainer) return;

    // Enhanced sticky behavior - ensure tabs stay sticky when scrolling
    const headerHeight = 65; // Mobile teacher header height
    let initialTop = tabsContainer.getBoundingClientRect().top + window.scrollY;
    let isFixed = false;
    let placeholderElement = null;

    function updateStickyPosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const tabsRect = tabsContainer.getBoundingClientRect();

      // When scrolling down past the initial position
      if (scrollTop >= initialTop - headerHeight) {
        if (!isFixed) {
          // Create placeholder to prevent layout shift
          if (!placeholderElement) {
            placeholderElement = document.createElement('div');
            placeholderElement.style.height = tabsContainer.offsetHeight + 'px';
            placeholderElement.style.visibility = 'hidden';
            placeholderElement.className = 'tabs-placeholder';
            tabsContainer.parentNode.insertBefore(placeholderElement, tabsContainer);
          }

          // Use class-based approach to avoid flickering
          tabsContainer.classList.add('is-fixed');
          isFixed = true;
        }
      } else {
        // Reset to sticky when scrolling back up
        if (isFixed) {
          tabsContainer.classList.remove('is-fixed');

          // Remove placeholder
          if (placeholderElement && placeholderElement.parentNode) {
            placeholderElement.parentNode.removeChild(placeholderElement);
            placeholderElement = null;
          }

          isFixed = false;
        }
      }
    }

    // Initial check
    updateStickyPosition();

    // Throttle scroll events for better performance
    let ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateStickyPosition();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    // Recalculate initial position on resize
    window.addEventListener('resize', function () {
      // Remove fixed state temporarily to get accurate position
      const wasFixed = isFixed;
      if (wasFixed) {
        tabsContainer.classList.remove('is-fixed');
        if (placeholderElement && placeholderElement.parentNode) {
          placeholderElement.parentNode.removeChild(placeholderElement);
          placeholderElement = null;
        }
        isFixed = false;
      }

      initialTop = tabsContainer.getBoundingClientRect().top + window.scrollY;
      updateStickyPosition();
    });

    const publishedSectionId = tabsContainer.dataset.publishedSectionId || '';
    const recommendedSectionId = tabsContainer.dataset.recommendedSectionId || '';

    function findTargetSection(sectionId) {
      if (!sectionId) return null;

      // Normalize section ID - Shopify wraps sections with shopify-section- prefix
      let normalizedId = sectionId.trim();
      if (!normalizedId.startsWith('shopify-section-')) {
        normalizedId = `shopify-section-${normalizedId}`;
      }

      // Try to find by normalized ID first (Shopify wrapper div)
      let targetSection = document.getElementById(normalizedId);
      if (targetSection) return targetSection;

      // Try original ID if different
      if (sectionId !== normalizedId) {
        targetSection = document.getElementById(sectionId);
        if (targetSection) return targetSection;
      }

      // Try finding by attribute selector
      targetSection = document.querySelector(`[id="${normalizedId}"]`);
      if (targetSection) return targetSection;

      // Try finding by attribute selector with original ID
      if (sectionId !== normalizedId) {
        targetSection = document.querySelector(`[id="${sectionId}"]`);
        if (targetSection) return targetSection;
      }

      // If it's a load-more section, try to find by data-testid and check parent
      if (sectionId.includes('load') || sectionId.includes('product')) {
        const loadMoreSections = document.querySelectorAll('[data-testid="load-more-product-grid"]');
        for (const loadMoreSection of loadMoreSections) {
          const parentSection = loadMoreSection.closest('[id^="shopify-section-"]');
          if (
            parentSection &&
            (parentSection.id === normalizedId || parentSection.id.includes(sectionId.replace('shopify-section-', '')))
          ) {
            return parentSection;
          }
        }
      }

      return null;
    }

    function scrollToSection(targetSection) {
      if (!targetSection) return;

      // Calculate total offset: header height + tabs container height + extra spacing
      const tabsHeight = tabsContainer.offsetHeight || 57;
      const totalOffset = headerHeight + tabsHeight + 12;

      const elementPosition = targetSection.getBoundingClientRect().top;
      const currentScrollY = window.scrollY || window.pageYOffset;
      const offsetPosition = elementPosition + currentScrollY - totalOffset;

      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'smooth',
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const tabName = this.dataset.tab;

        // Remove active class from all tabs
        tabs.forEach((t) => t.classList.remove('mobile-product-tabs__tab--active'));

        // Add active class to clicked tab
        this.classList.add('mobile-product-tabs__tab--active');

        // Handle Published tab
        if (tabName === 'published') {
          const targetSection = findTargetSection(publishedSectionId);
          scrollToSection(targetSection);
        }

        // Handle Recommended tab
        if (tabName === 'recommended') {
          const targetSection = findTargetSection(recommendedSectionId);
          scrollToSection(targetSection);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids-store"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kids-store-menu')) {
    class KidsStoreMenu extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.prevButton = this.querySelector('[data-kids-store-prev]');
        this.nextButton = this.querySelector('[data-kids-store-next]');
        this.scroller = this.querySelector('[data-kids-store-scroller]');
        if (!this.scroller || !this.prevButton || !this.nextButton) return;

        const onPrev = () => this.scrollByDirection(-1);
        const onNext = () => this.scrollByDirection(1);
        const onUpdate = () => this.updateNav();

        this.prevButton.addEventListener('click', onPrev, { signal });
        this.nextButton.addEventListener('click', onNext, { signal });
        this.scroller.addEventListener('scroll', onUpdate, { signal, passive: true });
        window.addEventListener('resize', onUpdate, { signal });
        this.resizeObserver = new ResizeObserver(onUpdate);
        this.resizeObserver.observe(this.scroller);
        this.updateNav();
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      scrollByDirection(direction) {
        const scroller = this.querySelector('[data-kids-store-scroller]');
        if (!scroller) return;

        const firstItem = scroller.querySelector('.kids-store__item');
        const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : scroller.clientWidth * 0.6;
        const gap = Number.parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        scroller.scrollBy({
          left: direction * (itemWidth + gap) * 3,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      updateNav() {
        const scroller = this.querySelector('[data-kids-store-scroller]');
        const prevButton = this.querySelector('[data-kids-store-prev]');
        const nextButton = this.querySelector('[data-kids-store-next]');
        if (!scroller || !prevButton || !nextButton) return;

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const canScroll = maxScroll > 1;
        const atStart = scroller.scrollLeft <= 1;
        const atEnd = scroller.scrollLeft >= maxScroll - 1;

        prevButton.hidden = !canScroll || atStart;
        nextButton.hidden = !canScroll || atEnd;
        prevButton.disabled = prevButton.hidden;
        nextButton.disabled = nextButton.hidden;
      }
    }

    customElements.define('kids-store-menu', KidsStoreMenu);

    document.addEventListener('shopify:section:load', (event) => {
      const menu = event.target.querySelector('kids-store-menu');
      if (menu) menu.connectedCallback();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promotional-coupon-carousel')) {
    class PromotionalCouponCarousel extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.prevButton = this.querySelector('[data-coupon-prev]');
        this.nextButton = this.querySelector('[data-coupon-next]');
        this.scroller = this.querySelector('[data-coupon-scroller]');
        this.dots = this.querySelectorAll('[data-coupon-dot]');
        this.liveRegion = this.querySelector('[data-coupon-live]');
        if (!this.scroller) return;

        const onPrev = () => this.scrollByDirection(-1);
        const onNext = () => this.scrollByDirection(1);
        const onUpdate = () => this.updateUI();

        if (this.prevButton) this.prevButton.addEventListener('click', onPrev, { signal });
        if (this.nextButton) this.nextButton.addEventListener('click', onNext, { signal });
        this.scroller.addEventListener('scroll', onUpdate, { signal, passive: true });
        this.scroller.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        window.addEventListener('resize', onUpdate, { signal });

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener(
            'click',
            (event) => {
              if (event.target === dialog) dialog.close();
            },
            { signal }
          );
        });

        this.dots.forEach((dot) => {
          dot.addEventListener(
            'click',
            () => {
              const index = Number(dot.dataset.index);
              this.scrollToIndex(index);
            },
            { signal }
          );
        });

        this.resizeObserver = new ResizeObserver(onUpdate);
        this.resizeObserver.observe(this.scroller);
        this.updateUI();
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.scrollByDirection(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.scrollByDirection(1);
        }
      }

      onClick(event) {
        const closeBtn = event.target.closest('[data-coupon-dialog-close]');
        if (closeBtn) {
          const dialog = closeBtn.closest('dialog');
          if (dialog) dialog.close();
          return;
        }

        const detailsBtn = event.target.closest('[data-coupon-details]');
        if (detailsBtn) {
          const dialogId = detailsBtn.getAttribute('aria-controls');
          const dialog = dialogId ? document.getElementById(dialogId) : null;
          if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
          return;
        }

        const copyBtn = event.target.closest('[data-coupon-copy]');
        if (copyBtn) this.copyCode(copyBtn);
      }

      getItemMetrics() {
        const firstItem = this.scroller.querySelector('.promotional-coupon__item');
        const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : this.scroller.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(this.scroller).columnGap || getComputedStyle(this.scroller).gap) || 0;
        return { itemWidth, gap, step: itemWidth + gap };
      }

      scrollByDirection(direction) {
        const { itemWidth, gap, step } = this.getItemMetrics();
        const visible = Math.max(1, Math.round(this.scroller.clientWidth / (itemWidth + gap)));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.scroller.scrollBy({
          left: direction * step * visible,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      scrollToIndex(index) {
        const items = this.scroller.querySelectorAll('.promotional-coupon__item');
        const item = items[index];
        if (!item) return;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollTo({
          left: item.offsetLeft,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      copyCode(button) {
        const code = button.getAttribute('data-code');
        if (!code) return;

        const announce = () => {
          button.setAttribute('data-copied', '');
          if (this.liveRegion) this.liveRegion.textContent = 'Copied ' + code;
          window.setTimeout(() => {
            button.removeAttribute('data-copied');
            if (this.liveRegion) this.liveRegion.textContent = '';
          }, 1600);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(announce).catch(() => {});
        }
      }

      updateUI() {
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        const canScroll = maxScroll > 1;
        const atStart = this.scroller.scrollLeft <= 1;
        const atEnd = this.scroller.scrollLeft >= maxScroll - 1;

        this.classList.toggle('is-unscrollable', !canScroll);

        if (this.prevButton) {
          this.prevButton.hidden = !canScroll;
          this.prevButton.disabled = !canScroll || atStart;
          this.prevButton.setAttribute('aria-disabled', String(this.prevButton.disabled));
        }
        if (this.nextButton) {
          this.nextButton.hidden = !canScroll;
          this.nextButton.disabled = !canScroll || atEnd;
          this.nextButton.setAttribute('aria-disabled', String(this.nextButton.disabled));
        }

        const dotsWrap = this.querySelector('[data-coupon-dots]');
        if (dotsWrap) dotsWrap.hidden = !canScroll;

        if (!this.dots.length || !canScroll) return;

        const items = this.scroller.querySelectorAll('.promotional-coupon__item');
        let active = 0;
        let minDist = Infinity;
        items.forEach((item, index) => {
          const dist = Math.abs(item.offsetLeft - this.scroller.scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            active = index;
          }
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === active;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('promotional-coupon-carousel', PromotionalCouponCarousel);

    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('promotional-coupon-carousel');
      if (carousel) carousel.connectedCallback();
    });

    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('.promotional-coupon__item');
      if (!item) return;
      const carousel = item.closest('promotional-coupon-carousel');
      if (!carousel || !carousel.scroller) return;
      item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-coupon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promotional-coupon-carousel')) {
    class PromotionalCouponCarousel extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.prevButton = this.querySelector('[data-coupon-prev]');
        this.nextButton = this.querySelector('[data-coupon-next]');
        this.scroller = this.querySelector('[data-coupon-scroller]');
        this.dots = this.querySelectorAll('[data-coupon-dot]');
        this.liveRegion = this.querySelector('[data-coupon-live]');
        if (!this.scroller) return;

        const onPrev = () => this.scrollByDirection(-1);
        const onNext = () => this.scrollByDirection(1);
        const onUpdate = () => this.updateUI();

        if (this.prevButton) this.prevButton.addEventListener('click', onPrev, { signal });
        if (this.nextButton) this.nextButton.addEventListener('click', onNext, { signal });
        this.scroller.addEventListener('scroll', onUpdate, { signal, passive: true });
        this.scroller.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        window.addEventListener('resize', onUpdate, { signal });

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener(
            'click',
            (event) => {
              if (event.target === dialog) dialog.close();
            },
            { signal }
          );
        });

        this.dots.forEach((dot) => {
          dot.addEventListener(
            'click',
            () => {
              const index = Number(dot.dataset.index);
              this.scrollToIndex(index);
            },
            { signal }
          );
        });

        this.resizeObserver = new ResizeObserver(onUpdate);
        this.resizeObserver.observe(this.scroller);
        this.updateUI();
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.scrollByDirection(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.scrollByDirection(1);
        }
      }

      onClick(event) {
        const closeBtn = event.target.closest('[data-coupon-dialog-close]');
        if (closeBtn) {
          const dialog = closeBtn.closest('dialog');
          if (dialog) dialog.close();
          return;
        }

        const detailsBtn = event.target.closest('[data-coupon-details]');
        if (detailsBtn) {
          const dialogId = detailsBtn.getAttribute('aria-controls');
          const dialog = dialogId ? document.getElementById(dialogId) : null;
          if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
          return;
        }

        const copyBtn = event.target.closest('[data-coupon-copy]');
        if (copyBtn) this.copyCode(copyBtn);
      }

      getItemMetrics() {
        const firstItem = this.scroller.querySelector('.promotional-coupon__item');
        const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : this.scroller.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(this.scroller).columnGap || getComputedStyle(this.scroller).gap) || 0;
        return { itemWidth, gap, step: itemWidth + gap };
      }

      scrollByDirection(direction) {
        const { itemWidth, gap, step } = this.getItemMetrics();
        const visible = Math.max(1, Math.round(this.scroller.clientWidth / (itemWidth + gap)));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.scroller.scrollBy({
          left: direction * step * visible,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      scrollToIndex(index) {
        const items = this.scroller.querySelectorAll('.promotional-coupon__item');
        const item = items[index];
        if (!item) return;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollTo({
          left: item.offsetLeft,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      copyCode(button) {
        const code = button.getAttribute('data-code');
        if (!code) return;

        const announce = () => {
          button.setAttribute('data-copied', '');
          if (this.liveRegion) this.liveRegion.textContent = 'Copied ' + code;
          window.setTimeout(() => {
            button.removeAttribute('data-copied');
            if (this.liveRegion) this.liveRegion.textContent = '';
          }, 1600);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(announce).catch(() => {});
        }
      }

      updateUI() {
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        const canScroll = maxScroll > 1;
        const atStart = this.scroller.scrollLeft <= 1;
        const atEnd = this.scroller.scrollLeft >= maxScroll - 1;

        this.classList.toggle('is-unscrollable', !canScroll);

        if (this.prevButton) {
          this.prevButton.hidden = !canScroll;
          this.prevButton.disabled = !canScroll || atStart;
          this.prevButton.setAttribute('aria-disabled', String(this.prevButton.disabled));
        }
        if (this.nextButton) {
          this.nextButton.hidden = !canScroll;
          this.nextButton.disabled = !canScroll || atEnd;
          this.nextButton.setAttribute('aria-disabled', String(this.nextButton.disabled));
        }

        const dotsWrap = this.querySelector('[data-coupon-dots]');
        if (dotsWrap) dotsWrap.hidden = !canScroll;

        if (!this.dots.length || !canScroll) return;

        const items = this.scroller.querySelectorAll('.promotional-coupon__item');
        let active = 0;
        let minDist = Infinity;
        items.forEach((item, index) => {
          const dist = Math.abs(item.offsetLeft - this.scroller.scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            active = index;
          }
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === active;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('promotional-coupon-carousel', PromotionalCouponCarousel);

    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('promotional-coupon-carousel');
      if (carousel) carousel.connectedCallback();
    });

    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('.promotional-coupon__item');
      if (!item) return;
      const carousel = item.closest('promotional-coupon-carousel');
      if (!carousel || !carousel.scroller) return;
      item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
